import { gql } from '../../../types/__codegen__/sanity';

export const GET_PRODUCT_OPTION_QUERY = gql(`
  query getProductOption($id: String) {
    allProductOption(where: { identifier: { current: { eq: $id } } }) {
      identifier {
        current
      }
      name
      descriptionRaw
      urlObject {
        ...UrlObjectFields
      }
      imageObject {
        ...ImageObjectFields
      }
      brandCampaigns {
        sloganRaw
        descriptionRaw
        urlObject {
          ...UrlObjectFields
        }
        imageObject {
          ...ImageObjectFields
        }
      }
      productFeatures {
        feature {
          name
        }
        disclaimerRaw
        urlObject {
          ...UrlObjectFields
        }
      }
      howTo {
        ...HowToFields
      }
      valuePropositionGroup {
        title
        descriptionRaw
        valuePropositions {
          sloganRaw
          summaryRaw
          urlObject {
            ...UrlObjectFields
          }
          imageObject {
            ...ImageObjectFields
          }
        }
      }
      commonQuestions {
        title
        summaryRaw
        imageObject {
          ...ImageObjectFields
        }
        questions {
          name
          question
          answerRaw
        }
      }
      tiles {
        ...TileFields
      }
      termsAndConditions {
        descriptionRaw
        footnotes {
          linkReferenceSymbol
          descriptionRaw
        }
        epilogueRaw
      }
      whatsCovered {
        title
        descriptionRaw
        image {
          ...ImageObjectFields
        }
        includedSection {
          title
          descriptionRaw
          isCovered
          items {
            name
            descriptionRaw
          }
          termsAndConditionsRaw
        }
        excludedSection {
          title
          descriptionRaw
          isCovered
          items {
            name
            descriptionRaw
          }
          termsAndConditionsRaw
        }
      }
    }
  }
`);
